module.exports = __webpack_public_path__ + "img/Flunder_4.52006bb6.jpg";